import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../css/components/controls/HrnbDatePicker.css";

function toLocalDateString(date) {
    // Форматируем Date в yyyy-MM-dd по локальному времени
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/**
 * Приводит значение к Date по локальному времени.
 * Поддерживает Date, "yyyy-MM-dd" и полные ISO-строки (например, из бэкенда:
 * "1990-05-15T00:00:00.000+00:00"), которые иначе парсятся со сдвигом часового пояса.
 */
function parseDateValue(value) {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    const str = String(value).trim();
    // Только дата yyyy-MM-dd — добавляем полдень, чтобы избежать сдвига часового пояса
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
        const d = new Date(`${str}T12:00:00`);
        return isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
}

export default function HrnbDatePicker({
                                           label,
                                           value,
                                           onChange,
                                           minDate,
                                           maxDate,
                                           disabled = false,
                                           className = "",
                                           error = "",
                                           hint = "",
                                           placeholder = "Выберите дату",
                                           ...props
                                       }) {
    const selectedDate = parseDateValue(value);

    return (
        <div className={`hrnb-datepicker-wrap ${className} ${disabled ? "hrnb-datepicker--disabled" : ""}`}>
            {label && <label className="hrnb-datepicker__label">{label}</label>}
            <ReactDatePicker
                selected={selectedDate}
                onChange={date => onChange(date ? toLocalDateString(date) : "")}
                minDate={parseDateValue(minDate) || undefined}
                maxDate={parseDateValue(maxDate) || undefined}
                disabled={disabled}
                placeholderText={placeholder}
                dateFormat="dd.MM.yyyy"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                scrollableYearDropdown
                yearDropdownItemNumber={100}
                className={`hrnb-datepicker__input${error ? " hrnb-datepicker__input--error" : ""}`}
                calendarClassName="hrnb-datepicker__calendar"
                popperClassName="hrnb-datepicker__popper"
                {...props}
            />
            {error
                ? <div className="hrnb-datepicker__error">{error}</div>
                : hint && <div className="hrnb-datepicker__hint">{hint}</div>
            }
        </div>
    );
}
